import React from 'react';
import style from './DetailsInnerHeader.css';

export const DetailsInnerHeader = ({ onActiveTabClick, initialActiveTabIndex, tabs }) => {
    const onItemClick = index => {
        onActiveTabClick(index);
    };

    const listItems = tabs.map((el, index) => {
        return (
            <li key={el.name + index}
                onClick={() => onItemClick(index)}
                className={initialActiveTabIndex === index ? style.active : ''}>
                {el.titleKey}
            </li>);
    });

    return (
        <div className={style.newUIMenuWrapper} >
            <ul className={style.newUIMenuContainer}>
                {listItems}
            </ul>
        </div>
    );
};

